// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"partnerships_imageWrapper__K74BQ"};